import React, { useState, useEffect } from "react";
import "./filterModal";
import axios from "axios";
import "./FilterModalForFolder.css"
import Cookies from "js-cookie";
import api from "../chat/api";
const FilterModalForFolder = ({ isOpen, onClose, onApply, setFiles, folderId, src ,setIsFilterApplied,selectedFilters,setSelectedFilters}) => {
  const [token, setToken] = useState("");
  // const [selectedFilters, setSelectedFilters] = useState({
  //   normalDocument: false,
  //   contract: false,
  //   invoice: false,
  //   spreadsheet: false,
  // });
  const [fileType, setFileType] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rangeDate, setRangeDate] = useState("");

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    } else {
      console.error("Token is missing from localStorage");
    }
  }, []);

  

  const [activeTab, setActiveTab] = useState("FileType");

  const handleApply = async () => {
    try {
      const params = {
        file_type: fileType.length > 0 ? fileType.join(",") : undefined,
        ...(rangeDate
          ? { date_range: rangeDate }
          : {
              from_date: fromDate || undefined,
              to_date: toDate || undefined,
            }),
      };

      const response = await api.get(
        `api/v1/readpdf/filter-files-in-folder/${folderId}/`,
        {
          params,
          // headers: {
          //   Authorization: `Token ${token}`,
          //   "Content-Type": "application/json",
          // },
        }
      );

      if (response.status === 200) {
        setFileType([]);
        setFromDate("");
        setToDate("");
        setRangeDate("");
        src === "folder"
          ? setFiles({
              documents: response.data.files.map((file) => ({
                ...file,
                key: file.key || "",
                pdf_url: file.url || "", 
              })),
            })
          : setFiles(
              response.data.files.map((file) => ({
                ...file,
                key: file.key || "", 
              }))
            );
            setIsFilterApplied(true);
      }
      
    } catch (err) {
    }
    onClose();
  };

  const handleCheckboxChange = (type) => {
    setSelectedFilters((prev) => {
      const updatedFilters = { ...prev, [type]: !prev[type] };

      setFileType(() => {
        const fileTypeMapping = {
          normalDocument: "normal_document",
          contract: "contract",
          invoice: "invoice",
          spreadsheet: "spreadsheet",
        };

        const selectedFileTypes = Object.keys(updatedFilters)
          .filter((key) => updatedFilters[key])
          .map((key) => fileTypeMapping[key]);

        return selectedFileTypes;
      });

      return updatedFilters;
    });
  };

const clearAllFilters = async () => {
  try {
    // Reset filters
    setSelectedFilters({
      normalDocument: false,
      contract: false,
      invoice: false,
      spreadsheet: false,
    });
    setFileType([]);
    setFromDate("");
    setToDate("");
    setRangeDate("");

    
    const response = await api.get(
      `api/v1/readpdf/files-in-the-folder/${folderId}/`
    );

    if (response.status === 200) {
      src === "folder"
        ? setFiles({
            documents: response.data.documents.map((file) => ({
              ...file,
              key: file.key || "",
              pdf_url: file.url || "",
            })),
          })
        : setFiles(
            response.data.files.map((file) => ({
              ...file,
              key: file.key || "",
            }))
          );


      setIsFilterApplied(false);
    } else {
      console.error("Failed to fetch all files.");
    }
  } catch (error) {
    console.error("Error fetching all files:", error);
  } finally {
    onClose();
  }
};

  
  

  const isDatePickerDisabled = rangeDate !== "";

  if (!isOpen) return null;

  return (
  <div className="filter-modal-overlay-doc">
      <div className="filter-modal-doc-under">
      <button className="close-button-folder" onClick={onClose}>&times;</button>
        <h2>Filter Files</h2>
        <div className="Display">
         

          {activeTab === "FileType" && (
            <div className="filter-options">
              <div className="Header-doc-filter-folder">
 <p>Choose which file types to show in results </p>              </div>
              <label>
                <input
                  type="checkbox"
                  checked={selectedFilters.normalDocument}
                  onChange={() => handleCheckboxChange("normalDocument")}
                  className="chekcbox-doc-filter"
                />
                Normal Document
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={selectedFilters.contract}
                  onChange={() => handleCheckboxChange("contract")}
                  className="chekcbox-doc-filter"
                />
                Contract
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={selectedFilters.invoice}
                  onChange={() => handleCheckboxChange("invoice")}
                  className="chekcbox-doc-filter"
                />
                Invoice
              </label>
              <label>
  <input
    type="checkbox"
    checked={selectedFilters.spreadsheet}
    onChange={() => handleCheckboxChange("spreadsheet")}
    className="chekcbox-doc-filter"
  />
  Spreadsheet
</label>

            </div>
          )}
        </div>

        <div className="filter-actions-folder">
          <button onClick={clearAllFilters} className="filter-actions-folder-button">
            Clear All
          </button>
          <button onClick={handleApply} className="filter-actions-folder-buttons">
            Apply filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModalForFolder;